import store from '../store';
import { push } from 'connected-react-router';
import { queryString as queryStringAction } from '../actions/uri_actions';
import { openCloseAdvancedFilter } from '../reducers/filterReducer';
import { getAllAdvancedFilterQueryParameters, OPEN_FILTER_QUERY } from '../components/AdvancedFilter/filter_constants';
import { setSalesChannelName } from './sales_channel';
import { isSearchPageOpen } from '../selectors/router_selector';
import { scrollTo } from '../actions/view';
import * as QueryParams from '../const/query_params';
import { getSelectedCustomerType } from '../selectors/customer_type_selector';
import * as modal from '../reducers/modalReducer';
import { openEmailConfirmationModal, openVerifyResetPasswordModal } from '../actions/modal';

const MobileDetect = require('mobile-detect');

export const saveQueryString = () => {
  const queryStringIdx = window.location.href.indexOf('?');
  if (queryStringIdx > -1) {
    const queryString = window.location.href.slice(queryStringIdx);
    store.dispatch(queryStringAction(queryString));
  }
};

const restoreAdvancedFilterOpenState = () => {
  const shouldAdvancedFilterOpen = new RegExp(`[?&]${OPEN_FILTER_QUERY}=`).test(window.location.search);
  if (
    !store.getState().filter.isAdvancedFilterOpen
    && shouldAdvancedFilterOpen
    && !new MobileDetect(window.navigator.userAgent).phone()
  ) {
    store.dispatch(openCloseAdvancedFilter());
  }
};

const restoreScrollPosition = () => {
  if (isSearchPageOpen(store.getState())) {
    store.dispatch(scrollTo(0));
  }
};

export const getQueryParameter = (param) => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(param);
};

export const restoreAppStateBasedOnQueryParameters = () => {
  saveQueryString();
  restoreScrollPosition();
  restoreAdvancedFilterOpenState();
  setSalesChannelName(window.location);

  if (window.location.search.indexOf(QueryParams.EMAIL_RETRIEVE_TOKEN) > -1) {
    store.dispatch(
      openEmailConfirmationModal({
        retrieveToken: getQueryParameter(QueryParams.EMAIL_RETRIEVE_TOKEN),
      }),
    );
  }
};

export const setCustomerTypeQueryParameter = (customerType) => {
  insertUrlParam(QueryParams.CUSTOMER_TYPE, customerType);
};

function insertUrlParam(key, value) {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.set(key, value);
  const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState({ path: newurl }, '', newurl);
}

export const getQueryParameters = () => {
  const state = store.getState();
  const { router } = state;
  const selectedCustomerType = getSelectedCustomerType(state);

  if (!router.location.search.includes(QueryParams.CUSTOMER_TYPE)) {
    let prefix = '&';

    if (router.location.search === '') {
      prefix = '?';
    }

    return `${router.location.search}${prefix}${QueryParams.CUSTOMER_TYPE}=${selectedCustomerType}`;
  }

  const advancedFilterQueries = [
    QueryParams.COLLECTIONS,
    QueryParams.QUERY,
    QueryParams.SEARCH_TYPE,
  ].concat(getAllAdvancedFilterQueryParameters());

  // clear advanced filter query parameters
  return router.location.search.split('&').filter((query) => {
    const q = query.split('=');

    if (q.length === 0) {
      return false;
    }

    const slug = q[0].replace(/\?/, '');

    if (slug === QueryParams.EMAIL_RETRIEVE_TOKEN) return false;
    if (slug === QueryParams.RESET_PASSWORD_RETRIEVE_TOKEN) return false;

    return advancedFilterQueries.indexOf(slug) === -1;
  }).join('&');
};

export const pushWithQueryParams = pathname => push({ pathname, search: getQueryParameters() });



// WEBPACK FOOTER //
// ./src/services/uri.js